import { render, staticRenderFns } from "./StandardBuild.vue?vue&type=template&id=2233a41a&scoped=true&"
import script from "./StandardBuild.vue?vue&type=script&lang=js&"
export * from "./StandardBuild.vue?vue&type=script&lang=js&"
import style0 from "./StandardBuild.vue?vue&type=style&index=0&id=2233a41a&scoped=true&lang=css&"
import style1 from "./StandardBuild.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2233a41a",
  null
  
)

export default component.exports